import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/profile/cs_close_n.png'


const _hoisted_1 = { class: "name_pop" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "defaultButton" }

import { ref, watch, computed } from 'vue'
import InputField from './inputField.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import { useUserStore } from '@/stores/user'
import MainButton from '../../components/common/mainButton.vue'
import { updateNickName } from '@/view/profile/supportScript'


export default /*@__PURE__*/_defineComponent({
  __name: 'nameEditPopup',
  setup(__props, { expose: __expose }) {

const userStore = useUserStore()
const id = computed(() => userStore.id)
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const userName = ref('')
const isUpdateField = ref(false)

const open = (name: string) => {
    userName.value = name
    show.value = true
}

const close = () => {
    show.value = false
}

const onUpdateNickName = () => {
    updateNickName(id.value, userName.value, show, toastContent, isSuccess, statusRef)
}

watch(() => userName.value, (newVal) => {
    if (newVal) {
        isUpdateField.value = true
    } else {
        isUpdateField.value = false
    }

})
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    style: {
        minWidth: '100%',
        minHeight: '100%',
        background: '#003534',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_row, { class: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "22",
              style: {"display":"flex","justify-content":"center","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.brandName')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "2" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: close
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InputField, {
            modelValue: userName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userName).value = $event)),
            labelText: _ctx.$t('profile.enterNickName')
          }, null, 8, ["modelValue", "labelText"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_button, {
              disabled: !isUpdateField.value,
              onClick: onUpdateNickName,
              class: "custom-save-btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createVNode(StatusPopup, {
        ref_key: "statusRef",
        ref: statusRef,
        "is-show-success": isSuccess.value,
        content: toastContent.value
      }, null, 8, ["is-show-success", "content"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})